import React from 'react';
import PropTypes from 'prop-types';
import DefaultCategories from './DefaultCategories';
import MobileCategories from './MobileCategories';
import { appHandler } from '../lib/apphandler';
import { get } from 'lodash';
import { MISC } from '../lib/constants';

const MyAppsList = props => {
  const { experimentation, location, favorites, app } = props,
    { isDesktop } = app.deviceInfo,
    handler = appHandler(props, this),
    pathname = get(location, 'pathname', '');

  if (
    pathname.includes('myapps') &&
    !get(experimentation, MISC.DISCOVER, false)
  ) {
    handler.changeTab(favorites.length ? '1' : '2');
  }

  return (
    <div id="merchanthub-apps-list">
      {isDesktop ? (
        <DefaultCategories {...props} {...handler} />
      ) : (
        <MobileCategories {...props} {...handler} />
      )}
    </div>
  );
};

MyAppsList.propTypes = {
  categories: PropTypes.array,
  categoryIndexes: PropTypes.object,
  favorites: PropTypes.array,
  activeKey: PropTypes.string,
  app: PropTypes.object,
  dispatch: PropTypes.func,
  updateTab: PropTypes.func,
  updateApp: PropTypes.func,
  updatePath: PropTypes.func,
  recordClick: PropTypes.func,
  tracking: PropTypes.object,
  toggleToolFavorite: PropTypes.func,
  search: PropTypes.object,
  recommendations: PropTypes.array,
  experimentation: PropTypes.object,
  location: PropTypes.object
};

export default MyAppsList;
